import { uniqueId } from 'lodash';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS,FETCH_END,FETCH_LOADING } from '../../@jumbo/constants/ActionTypes';

export const fetchSuccess = message => {
  return dispatch => {
    dispatch({
      type: FETCH_SUCCESS,
      messageTicks:uniqueId("fetchSuccess_"),
      payload: message || '',
    });
  };
};
export const fetchError = error => {
  return dispatch => {
    dispatch({
      type: FETCH_ERROR,
      messageTicks:uniqueId("fetchError_"),
      payload: error,
    });
  };
};

export const fetchStart = (flag) => {
  return dispatch => {
    dispatch({
      type: FETCH_START,
      flag
    });
  };
};

export const fetchEnd = (flag) => {
  return dispatch => {
    dispatch({
      type: FETCH_END,
      flag
    });
  };
};


 //因为fetchStart会受到fetchError和fetchSuccess影响loading效果，所以这里新增了fetchLoading
export const fetchLoading = (flag) => { 
  return dispatch => {
    dispatch({
      type: FETCH_LOADING,
      flag
    });
  };
};
